import { render } from "./InlineMessage.vue?vue&type=template&id=ae627aa8&scoped=true"
import script from "./InlineMessage.vue?vue&type=script&lang=js"
export * from "./InlineMessage.vue?vue&type=script&lang=js"

import "./InlineMessage.vue?vue&type=style&index=0&id=ae627aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae627aa8"]])

export default __exports__